import type { PropertyHotel } from "#shared/types/propertyHotel.ts";

export default function useHotels() {
  const hotels = useState<PropertyHotel[]>("hotels", () => shallowRef([]));

  const hotelsByCity = computed<Record<string, PropertyHotel[]>>(() => {
    return hotels.value.reduce(
      (acc: Record<string, PropertyHotel[]>, hotel) => {
        const city = hotel.city;
        if (!acc[city.code]) {
          acc[city.code] = [];
        }
        acc[city.code].push(hotel);
        return acc;
      },
      {},
    );
  });

  const hotelsByContinent = computed<Record<string, PropertyHotel[]>>(() => {
    if (hotels.value.length === 0) {
      return {};
    }
    return hotels.value.reduce(
      (acc: Record<string, PropertyHotel[]>, hotel) => {
        const continent = hotel.continent;
        if (!continent) {
          return;
        }
        if (!acc[continent.code]) {
          acc[continent.code] = [];
        }
        acc[continent.code].push(hotel);
        return acc;
      },
      {},
    );
  });

  const hotelsByContinentAndCity = computed<
    Record<string, Record<string, PropertyHotel[]>>
  >(() => {
    return hotels.value.reduce(
      (acc, hotel) => {
        const continentName = hotel.continent.code;
        const cityName = hotel.city.code;

        if (!acc[continentName]) {
          acc[continentName] = {};
        }

        if (!acc[continentName][cityName]) {
          acc[continentName][cityName] = [];
        }

        acc[continentName][cityName].push(hotel);

        return acc;
      },
      {} as Record<string, Record<string, PropertyHotel[]>>,
    );
  });

  const setHotels = (newHotels: PropertyHotel[]) => {
    hotels.value = newHotels;
  };

  return {
    hotels: readonly(hotels),
    hotelsByContinent,
    hotelsByContinentAndCity,
    hotelsByCity,
    setHotels,
  };
}
